// Concept-local React contexts. They carry presentation state from the Shell down to the page
// header and lists (breadcrumb, toolbar, list density) without touching the shared contract.
import { createContext, useContext, type ReactNode } from "react";

export interface Crumb {
  label: string;
  href: string;
}

export interface ConsoleShellState {
  /** Ancestors of the current page (Area › Space), derived from the sidebar model. */
  crumbs: Crumb[];
  /** Things-style toolbar slot (New task, When, Move, Search), shown in the top bar. */
  toolbar: ReactNode;
  sidebarCollapsed: boolean;
  onToggleSidebar: () => void;
}

export const ShellContext = createContext<ConsoleShellState>({
  crumbs: [],
  toolbar: null,
  sidebarCollapsed: false,
  onToggleSidebar: () => {},
});
export const useConsoleShell = () => useContext(ShellContext);

/**
 * How Console lists group their rows. Collection screens regroup by status (Linear). Today keeps
 * the Things structure (planned, due, completed), so it turns status grouping off.
 */
export const StatusGroupingContext = createContext(true);

/** The incoming group label for a task (e.g. its project) when status grouping replaced it. */
export const GroupLabelContext = createContext<string | null>(null);
